import { getChannelAPIPath } from '@treasury/core/http';

AchMasterRecipientService.$inject = ['$resource', '$q'];

export default function AchMasterRecipientService($resource, $q) {
    return {
        approveMasterRecipients,
        deleteMasterRecipients,
        getMasterRecipientAudits,
        getMasterRecipients,
        rejectMasterRecipients,
        saveMasterRecipient,
    };

    function getMasterRecipients(searchFilters) {
        const cancelPromise = $q.defer();
        const getRecipientsRequest = $resource(buildUrl('GetMasterRecipients'), null, {
            timeout: cancelPromise,
        }).save(searchFilters);
        return {
            promise: getRecipientsRequest.$promise,
            cancel() {
                cancelPromise.resolve();
            },
        };
    }

    function saveMasterRecipient(achMasterRecipients) {
        const savemasterRecipientsRequest = {
            saveableMasterRecipients: angular.isArray(achMasterRecipients)
                ? achMasterRecipients
                : [achMasterRecipients],
        };
        const saveRecipientRequest = $resource(buildUrl('SaveMasterRecipient')).save(
            savemasterRecipientsRequest
        );
        return saveRecipientRequest.$promise;
    }

    function approveMasterRecipients(achMasterRecipientIds) {
        const request = {
            achMasterRecipientIds,
        };
        const approveRecipientRequest = $resource(buildUrl('approve')).save(request);
        return approveRecipientRequest.$promise;
    }

    function rejectMasterRecipients(achMasterRecipientIds) {
        const request = {
            achMasterRecipientIds,
        };
        const rejectRecipientRequest = $resource(buildUrl('reject')).save(request);
        return rejectRecipientRequest.$promise;
    }

    function deleteMasterRecipients(achMasterRecipientIds) {
        const request = {
            achMasterRecipientIds,
        };
        const deleteRecipientRequest = $resource(buildUrl('delete')).save(request);
        return deleteRecipientRequest.$promise;
    }

    function getMasterRecipientAudits(achMasterRecipientId) {
        return $resource(buildUrl('audits/:achMasterRecipientId'), {
            achMasterRecipientId,
        }).get().$promise;
    }

    function buildUrl(actionPath) {
        return `${getChannelAPIPath()}AchMasterRecipient/${actionPath}`;
    }
}
